import { Component, h } from 'preact'
import globals, { subscribe } from '../../utils/globals'
import algoliasearch from 'algoliasearch/lite'
import { Tag } from './PublicTagSelect'
import Icon from '../assets'
import { Credentials, getSearchToken } from '../../services/algoliaService'

interface Props {
  isTagSelected: (tag: string) => boolean
  selectPublicTag: (tag: Tag, remainFocusOnInput: boolean) => void
}
interface State {
  suggestedTags: string[]
  index?: algoliasearch.Index
}
interface HitWithTags {
  tags: string[] | null
}
interface Hash<T> {
  [key: string]: T
}

export default class AutoSuggestTags extends Component<Props, State> {
  // @ts-expect-error
  index: algoliasearch.Index

  constructor (props: Props) {
    super(props)
    this.state = {
      suggestedTags: []
    }
    subscribe('title_changed', ({ title }: { title: string }) => this.autoSuggest(title))
    this.cb = this.cb.bind(this)
  }

  cb (data: Credentials) {
    const client = algoliasearch(data.client_id, data.token)
    this.setState({ index: client.initIndex(`${globals('communityId')}`) })
  }

  async componentDidMount () {
    await getSearchToken(this.cb)
  }

  autoSuggest (topicName: string) {
    const { index } = this.state
    if (topicName === '' || index === undefined) {
      this.setState({ suggestedTags: [] })
      return
    }
    index.search({ query: topicName, attributesToRetrieve: ['title', 'tags'] }).then(({ hits }: { hits: HitWithTags[] }) => {
      const tagSet: Hash<number> = {}
      const results = hits.reduce((result, hit) => {
        hit.tags?.forEach(tag => {
          Object.prototype.hasOwnProperty.call(result, tag) ? result[tag]++ : result[tag] = 1
        })
        return result
      }, tagSet)
      this.setState({ suggestedTags: Object.keys(results).sort((a, b) => results[b] - results[a]).slice(0, 3) })
    })
  }

  render ({ isTagSelected, selectPublicTag }: Props, { suggestedTags }: State) {
    return suggestedTags.length > 0 && <div class='public-tag-suggestions-container'>
      {
        suggestedTags.map(tag => isTagSelected(tag)
          ? null
          : <div
              class='suggested-public-tag' onClick={
          () => selectPublicTag({ name: tag }, false)
        }
            >{tag}&nbsp;<Icon icon='add' size={16} /></div>)
      }
    </div>
  }
}
